export default __webpack_public_path__ + "static/media/Group1462111.b5506129.svg";